import React from "react";
import BusinessIcon from "@mui/icons-material/Business";
import FormValidation from "../../components/FormValidation/FormValidation.js";
import formFields from "../../config/formFields.json";

const AddSkillCategory = ({
  open,
  onClose,
  initialData = null,
  onSubmit
}) => {
  const isEdit = !!initialData;

  const initialValues = {
    category_name: initialData?.skill_cat_name || ""
  };

  return (
    <FormValidation
      open={open}
      onClose={onClose}
      initialData={initialValues}
      onSubmit={onSubmit}
      formFields={formFields.skillCategory.basic.fields}
      title="Skill Category"
      icon={BusinessIcon}
      isEdit={isEdit}
    />
  );
};

export default AddSkillCategory;
